import { useTranslation } from 'react-i18next';
import { curationFailureMessageKey } from '@/lib/projects/curationFailureMessageKey';
import { isEditOnlyEligible } from '@/lib/projects/editOnly';
import { EditOnlyRescue } from '@/components/projects/EditOnlyRescue';

interface FailedProjectNoticeProps {
  kind: 'project' | 'library';
  id?: string | null;
  failureCode?: string | null;
  videoUrl?: string | null;
  durationSeconds?: number | null;
  // start_time of a ranged project/library (absolute source time).
  rangeStart?: number | null;
  onConverted?: () => void;
}

// The body of the failed project/library screen, shared by the four pages
// that show it: the failure message and, when the video has no speech, the
// edit-only picker.
export function FailedProjectNotice({
  kind, id, failureCode, videoUrl, durationSeconds, rangeStart, onConverted,
}: FailedProjectNoticeProps) {
  const { t } = useTranslation();
  const duration = durationSeconds && durationSeconds > 0 ? durationSeconds : null;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-6 px-4 py-8">
      <p className="max-w-md text-center text-sm text-muted-foreground">
        {t(curationFailureMessageKey(failureCode))}
      </p>
      {id && duration !== null && isEditOnlyEligible(failureCode) && (
        <EditOnlyRescue
          kind={kind}
          id={id}
          videoUrl={videoUrl}
          durationSeconds={duration}
          rangeStart={rangeStart && rangeStart > 0 ? rangeStart : 0}
          onConverted={onConverted}
        />
      )}
    </div>
  );
}
